document.addEventListener("DOMContentLoaded", function () {
    const collapseLink = document.querySelector('.filter-more-link');
    const collapseContent = document.querySelector('.collapse-content');

    if (collapseContent) {
        collapseContent.style.display = 'none';

        if (collapseLink) {
            collapseLink.addEventListener('click', function (event) {
                event.preventDefault();

                if (collapseContent.style.display === 'none') {
                    collapseContent.style.display = 'flex';
                    collapseLink.textContent = 'Minder filter opties';
                } else {
                    collapseContent.style.display = 'none';
                    collapseLink.textContent = 'Meer filter opties';
                }
            });
        }
    }
});